import { Role } from '../../models/role.model';
import { RoleService } from '../../services/role.service';
import { Component, OnInit, Inject, Optional } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-user-role-add-dialog',
  templateUrl: './user-role-add-dialog.component.html',
  styleUrls: ['./user-role-add-dialog.component.scss'],
})
export class UserRoleAddDialogComponent implements OnInit {
  roleForm!: FormGroup;
  constructor(public dialogRef: MatDialogRef<UserRoleAddDialogComponent>,
    private fb: FormBuilder,
    private roleService: RoleService,
    @Optional() @Inject(MAT_DIALOG_DATA) public role: Role) {

  }

  ngOnInit() {

    this.roleForm = this.fb.group({
      id: [null],
      name: [null, Validators.required],
      description: [null],
      active: [true]
    });

    if (this.role) {
      this.roleForm.patchValue({
        id: this.role.id,
        name: this.role.name,
        description: this.role.description,
        active: this.role.active
      });
    }
  }

  save() {
    if (this.roleForm.valid) {
      this.roleService.save(this.roleForm.value).subscribe(response => {
        if (response) {
          this.dialogRef.close({ success: response });
        }
      });
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }



  public get id(): string {
    return this.roleForm.get('id')?.value;
  }

}
